export const GetOfferData4 = [
	{
		title: '< 1000€',
		price_range_min:100,
		price_range_max:1000
	},
	{
		title: '1000€-1500€',
		price_range_min:1000,
		price_range_max:1500
	},
	{
		title: '1500€-2000€',
		price_range_min:1500,
		price_range_max:2000
	},
	{
		title: '2000€-2500€',
		price_range_min:2000,
		price_range_max:2500
	},
	{
		title: '2500€-3000€',
		price_range_min:2500,
		price_range_max:3000
	},
	{
		title: '>3000€',
		price_range_min:3000,
		price_range_max:10000
	}
]
